const initialState = {
   getTransactionsInProgress: true,
   getTransactionsPaginationInProgress: true,
   transactions: [],
   total: 0,
};

export default initialState;
